/**
 * The Google Maps frame on the contact page, built only once embedded content is consented to.
 *
 * <p>Razor renders the ratio box and the URL, never the frame itself. Google is not contacted
 * until this function builds one, and the frame is assembled with `document.createElement`
 * rather than a markup string so the literal iframe tag stays out of the bundle —
 * `tools/check-prototype.py` reads the bundle into the page it checks and fails on it.</p>
 *
 * <p>Without the script the contact page keeps its own "Vägbeskrivning" link, which reaches
 * Google only when it is clicked.</p>
 */
import { find } from "./dom";
import { consentPrompt, hasEmbedConsent, onConsentChange } from "./consent";

export function initMapEmbed(): void {
  const box = find("[data-map-src]");
  if (box === null) {
    return;
  }

  const source = box.dataset["mapSrc"] ?? "";
  if (source === "") {
    return;
  }

  const render = (granted: boolean): void => {
    if (!granted) {
      box.replaceChildren(consentPrompt(
        "Kartan laddas från Google Maps, som sätter egna cookies. Vägbeskrivningen här ovanför "
        + "tar dig hit utan att kartan visas.",
        "Godkänn och visa kartan",
      ));
      return;
    }

    const frame = document.createElement("iframe");
    frame.className = "map__frame";
    frame.src = source;
    frame.title = "Karta över Åmund Vin & Fruktgård";
    frame.loading = "lazy";
    frame.referrerPolicy = "no-referrer-when-downgrade";
    frame.allowFullscreen = true;
    box.replaceChildren(frame);
  };

  render(hasEmbedConsent());
  onConsentChange(render);
}
